





















import { Component, Prop, Vue } from "vue-property-decorator";
import { toTreeEntries, TreeEntry } from "@/utils/DeviceReportDisplay";

/**
 * Renders an arbitrary JSON value as a labelled tree.
 *
 * The device report payload is produced by the production test rig, whose steps, captured fields and
 * firmware list change with every hardware revision. Binding fixed fields would show nothing after
 * the next rig update, so the viewer walks whatever is there instead.
 *
 * Recursive, so it needs its own `name` to reference itself in its template. The shaping itself
 * lives in `DeviceReportDisplay`, where it can be tested without mounting anything.
 */
@Component({ name: "device-report-json-tree" })
export default class DeviceReportJsonTreeComponent extends Vue {
  @Prop({ required: true })
  value!: unknown;

  @Prop({ default: 0 })
  depth!: number;

  get entries(): TreeEntry[] {
    return toTreeEntries(this.value, this.depth);
  }
}
